import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  EventEmitter,
  Output,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
  ViewEncapsulation
} from '@angular/core';
import * as uuid from 'uuid';

import $ from 'jquery';
import moment, { Moment } from 'moment';
import 'daterangepicker';
import { NgForm, NgModel } from '@angular/forms';
import { TranslateService } from '../../services/translate/translate.service';
// Document: http://www.daterangepicker.com/

@Component({
  selector: 'sd-date-range-picker-control',
  templateUrl: './date-range-picker-control.component.html',
  styleUrls: ['../../assets/css/form.scss', './date-range-picker-control.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DateRangePickerControlComponent implements OnDestroy, AfterViewInit {
  private initialized = false;
  private pFromDate: any;
  private pToDate: any;
  private pMinDate: any = null;
  private pMaxDate: any = null;
  private jsFormat = 'MM/dd/yyyy HH:mm';
  private momentFormat = 'MM/DD/YYYY hh:mm';
  private get viewFormat() {
    let format = 'DD/MM/YYYY';
    if (this.type === 'datetime') {
      format = 'DD/MM/YYYY hh:mm';
    } else if (this.type === 'time') {
      format = 'hh:mm';
    }
    return format;
  }
  private get format() {
    let format = 'MM/DD/YYYY';
    if (this.type === 'datetime') {
      format = 'MM/DD/YYYY hh:mm';
    } else if (this.type === 'time') {
      format = 'MM/DD/YYYY hh:mm';
    }
    return format;
  }
  name = uuid.v4();
  model = '';
  @Input() form: NgForm;
  @Input() type: 'datetime' | 'date' | 'time' = 'datetime';
  @Input() disabled = false;
  @Input() required = false;
  @Input() label: string;
  @Input() set minDate(val: string | Date | number) {
    if (!Date.isDate(val)) {
      val = null;
    } else {
      val = Date.toFormat(val, this.jsFormat);
    }
    this.pMinDate = val;
    if (this.initialized) {
      this.setOption();
    }
  }
  @Input() set maxDate(val: string | Date | number) {
    if (!Date.isDate(val)) {
      val = null;
    } else {
      val = Date.toFormat(val, this.jsFormat);
    }
    this.pMaxDate = val;
    if (this.initialized) {
      this.setOption();
    }
  }
  @Input() set fromDate(val: any) {
    if (!Date.isDate(val)) {
      val = null;
    } else {
      val = Date.toFormat(val, this.jsFormat);
    }
    if (this.initialized) {
      if (this.pFromDate !== val) {
        ($(this.control.nativeElement) as any)
          .data('daterangepicker').setStartDate(val ? moment(val, this.momentFormat) : moment());
      }
      const startDate = val ? moment(val, this.momentFormat).format(this.viewFormat) : '';
      const toDate = this.pToDate ? moment(this.pToDate, this.momentFormat).format(this.viewFormat) : '';
      this.reload(startDate, toDate);
    }
    this.pFromDate = val;
    this.ref.detectChanges();
  }
  @Input() set toDate(val: any) {
    if (!Date.isDate(val)) {
      val = null;
    } else {
      val = Date.toFormat(val, this.jsFormat);
    }
    if (this.initialized) {
      if (this.pToDate !== val) {
        ($(this.control.nativeElement) as any)
          .data('daterangepicker').setEndDate(val ? moment(val, this.momentFormat) : moment());
      }
      const startDate = this.pFromDate ? moment(this.pFromDate, this.momentFormat).format(this.viewFormat) : '';
      const toDate = val ? moment(val, this.momentFormat).format(this.viewFormat) : '';
      this.reload(startDate, toDate);
    }
    this.pToDate = val;
    this.ref.detectChanges();
  }
  @Output() sdChange = new EventEmitter();
  date: string;

  @Output() fromDateChange = new EventEmitter();
  @Output() toDateChange = new EventEmitter();

  @ViewChild('control') control: ElementRef;
  @ViewChild('formModel') formModel: NgModel;
  constructor(
    private ref: ChangeDetectorRef,
    private translateService: TranslateService) {
  }

  ngOnDestroy() {
    this.form?.removeControl(this.formModel);
  }

  ngAfterViewInit() {
    this.form?.addControl(this.formModel);
    this.onChanges();
    this.initialized = true;
    this.setOption();
    const startDate = this.pFromDate ? moment(this.pFromDate, this.momentFormat).format(this.viewFormat) : '';
    const toDate = this.pToDate ? moment(this.pToDate, this.momentFormat).format(this.viewFormat) : '';
    this.reload(startDate, toDate);
    this.ref.detectChanges();
  }

  onFocus = () => {
    $(this.control.nativeElement).trigger('blur');
  }

  private onChanges = () => {
  }

  private setOption() {
    if (this.initialized) {
      ($(this.control.nativeElement) as any).daterangepicker({
        autoUpdateInput: false,
        timePicker: this.type === 'datetime' || this.type === 'time',
        timePicker24Hour: true,
        locale: {
          // format: this.format,
          // separator: ' - ',
          applyLabel: this.translateService.translate('Apply'),
          cancelLabel: this.translateService.translate('Clear'),
          fromLabel: this.translateService.translate('From'),
          toLabel: this.translateService.translate('To'),
          customRangeLabel: this.translateService.translate('Custom'),
          weekLabel: 'W',
          daysOfWeek: [
            this.translateService.translate('Su'),
            this.translateService.translate('Mo'),
            this.translateService.translate('Tu'),
            this.translateService.translate('We'),
            this.translateService.translate('Th'),
            this.translateService.translate('Fr'),
            this.translateService.translate('Sa')
          ],
          monthNames: [
            this.translateService.translate('January'),
            this.translateService.translate('February'),
            this.translateService.translate('March'),
            this.translateService.translate('April'),
            this.translateService.translate('May'),
            this.translateService.translate('June'),
            this.translateService.translate('July'),
            this.translateService.translate('August'),
            this.translateService.translate('September'),
            this.translateService.translate('October'),
            this.translateService.translate('November'),
            this.translateService.translate('December')
          ],
          firstDay: 1
        },
        startDate: Date.isDate(this.pFromDate) ? moment(this.pFromDate, this.momentFormat) : undefined,
        endDate: Date.isDate(this.pToDate) ? moment(this.pToDate, this.momentFormat) : undefined,
        minDate: Date.isDate(this.pMinDate) ? moment(this.pMinDate, this.momentFormat) : undefined,
        maxDate: Date.isDate(this.pMaxDate) ? moment(this.pMaxDate, this.momentFormat) : undefined,
      }, (fDate: Moment, tDate: Moment, label: any) => {
        const fromDate = fDate.format(this.format);
        const toDate = tDate.format(this.format);
        this.pFromDate = fromDate;
        this.pToDate = toDate;
        this.fromDateChange.emit(this.pFromDate);
        this.toDateChange.emit(this.pToDate);
        this.sdChange.emit({ fromDate, toDate });
        this.ref.detectChanges();
      });
      ($(this.control.nativeElement) as any).on('apply.daterangepicker', (ev, picker: { startDate: Moment, endDate: Moment }) => {
        const startDate = picker.startDate?.format(this.viewFormat);
        const endDate = picker.endDate?.format(this.viewFormat);
        this.reload(startDate, endDate);
      });
      ($(this.control.nativeElement) as any).on('cancel.daterangepicker', this.clear);
    }
  }

  private clear = () => {
    // ($(this.control.nativeElement) as any).val('');
    this.model = '';
    const fromDate = null;
    const toDate = null;
    this.pFromDate = fromDate;
    this.pToDate = toDate;
    this.fromDateChange.emit(this.pFromDate);
    this.toDateChange.emit(this.pToDate);
    this.sdChange.emit({ fromDate, toDate });
    this.ref.detectChanges();
  }

  private reload = (startDate: string, endDate: string) => {
    if (!startDate || !endDate) {
      this.model = '';
    } else {
      this.model = startDate + ' - ' + endDate;
    }
    this.ref.detectChanges();
  }
}
